<div
	[aria-labelledby]="triggerId() + '-header'"
	aria-modal="true"
	data-test-id="sheet-container"
	role="dialog"
>
	<ng-content />
	<div
		#sheetContentWrapper
		[class]="
			cn(
				className(),
				sheetWidthClass(),
				isMobile() &&
					'inset-x-0 h-auto !max-h-[calc(100vh-48px)] !w-full border-t',
				isMobile() &&
					(showSheet()
						? '!top-auto bottom-0'
						: '-bottom-full top-auto'),
				showSheet() && !isMobile() && 'h-full',
				!isMobile() &&
					sheetAlignment() === 'right' &&
					(showSheet() ? 'right-0 border-l' : '-right-[50%]'),
				!isMobile() &&
					sheetAlignment() === 'left' &&
					(showSheet() ? 'left-0 border-r' : '-left-[50%]')
			)
		"
		class="fixed top-0 z-50 flex flex-col border-ui-100 bg-white transition-sheet duration-500"
		data-test-id="sheet-content"
	>
		<div class="flex flex-row border-b border-b-ui-100 p-4 sm:p-6">
			<div
				[id]="triggerId() + '-header'"
				class="w-full children:mb-0"
				data-test-id="sheet-header"
			>
				<ng-content select="vp-sheet-header" />
			</div>
			<button
				(click)="toggle()"
				class="size-5"
				data-test-id="sheet-close-button"
			>
				<svg-icon
					[svgAriaLabel]="'global.close' | translate"
					class="size-5 cursor-pointer"
					src="assets/icons/icon-cross.svg"
				/>
			</button>
		</div>
		@if (!isLoading()) {
			<ng-content
				data-test-id="sheet-content"
				select="vp-sheet-content"
			/>
		}
		@if (isLoading()) {
			<div
				class="flex h-18 items-center justify-center p-4 sm:p-6"
				data-test-id="sheet-loading-spinner"
			>
				<svg-icon
					class="block size-10 animate-spin text-black"
					src="assets/icons/icon-spinner.svg"
				/>
			</div>
		}
		@if (footerRef()) {
			<div
				[id]="triggerId() + '-footer'"
				class="mt-auto flex flex-row border-t border-t-ui-100 p-4 sm:p-6"
				data-test-id="sheet-footer"
			>
				<ng-content select="vp-sheet-footer" />
			</div>
		}
		<button (click)="toggle()" class="sr-only" type="button">
			{{ 'global.close' | translate }}
		</button>
	</div>
	<button
		[aria-label]="'global.close' | translate"
		[class]="
			cn(
				showSheet() &&
					'overlay-dark-3 fixed inset-x-0 top-0 z-20 size-full',
				!showSheet() && 'invisible hidden'
			)
		"
		(click)="hide()"
		class="transition-colors"
		tabindex="-1"
	></button>
</div>
